import { Fragment, useContext } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { hasFieldOverrideV2 } from '../../permissions/gates';
import { useStrategy } from '../../hooks/useStrategy';
import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import FilterOperatorDisplay from '../operator/FilterOperatorDisplay';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { isAnyEventTypeId } from '../../filterQueryFormat/ObjectTypeId';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerUnifiedEventRefinementsDisplay = ({
  logicGroup
}) => {
  const {
    filterFamily
  } = logicGroup;
  const {
    currencyCode,
    data,
    getIsUngated,
    props: {
      translationPrefix
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFieldDefinitions,
    getFilterFamilyObjectName,
    getReferencedObjectType,
    getSpecialOptionsForReferenceType,
    getValueResolver,
    getOperatorsForType
  } = useStrategy();
  const {
    getFieldLabelString
  } = useTranslationHelpers(filterFamily);
  const isUnifiedEvent = isAnyEventTypeId(filterFamily);
  if (!isUnifiedEvent || !logicGroup.refinements) {
    return null;
  }
  const refinements = logicGroup.refinements.conditions.valueSeq().toArray();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: ["\xA0", refinements.map((refinement, index) => /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(FilterOperatorDisplay, {
        currencyCode: currencyCode,
        data: data,
        fieldDefinitions: hasFieldOverrideV2(getIsUngated) ? ImmutableMap({}) : getFieldDefinitions(filterFamily),
        filterFamily: filterFamily,
        getFamilyValueResolver: getValueResolver.bind(null, filterFamily),
        getFilterFamilyObjectName: getFilterFamilyObjectName,
        getLabelString: getFieldLabelString,
        getReferencedObjectType: getReferencedObjectType.bind(null, filterFamily),
        getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
        getIsUngated: getIsUngated,
        includeObjectsWithNoAssociatedObjects: logicGroup.includeObjectsWithNoAssociatedObjects,
        isReadOnly: true,
        isXoEnabled: true,
        hideRestrictedAsset: true,
        translationPrefix: translationPrefix,
        operator: refinement,
        getOperatorsForType: getOperatorsForType
      })
    }, `filter-operator-display-${index}`))]
  });
};
export default ViewerUnifiedEventRefinementsDisplay;